import { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';

import './elements/searchable-select.css';
import './elements/searchable-select-user-frontend.css';

class FilteredDropDown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.value
    };
  }

  UNSAFE_componentWillMount() {
    const { model, dispatch } = this.props;

    dispatch(actions.change(model, this.props.value.value));
    this.setState({ value: this.props.value });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.value.value !== nextProps.value.value) {
      this.props.dispatch(actions.change(this.props.model, nextProps.value.value));
      this.setState({ value: nextProps.value });
    }
  }

  handleChange(val) {
    const { model, dispatch } = this.props;

    this.setState({ value: val });

    if (val == null) {
      dispatch(actions.change(model, ''));
    } else {
      dispatch(actions.change(model, val.value));
    }

    if (this.props.onChange && this.props.onChange !== undefined) {
      this.props.onChange(val);
    }
  }

  handleOnInputChange(inputValue) {
    const { onInputChange } = this.props;

    if (onInputChange) {
      return onInputChange(inputValue);
    }

    return inputValue;
  }

  render() {
    const {
      data, placeholder, disabled, isClearable
    } = this.props;
    const {value} = this.state;
    // Consumers pass an empty sentinel ({ value: '' }) for "no selection". Treat it as null so
    // react-select shows the placeholder and no clear (x) until a real option is picked — the
    // pre-v5 behaviour. A chosen option ({ value: <id> }) renders normally, with the x.
    const selected = value && value.value !== '' && value.value != null ? value : null;

    return (
      <Select
        className={`${!!window.location.pathname.match('/team/') || !!window.location.pathname.match('/admin/') ? '' : 'form-control'} `}
        classNamePrefix="rs"
        // react-select v1 single-selects were clearable by default; v5 is not, so restore the
        // clear (x) control. Overridable per consumer, defaults to true to match prior behaviour.
        isClearable={isClearable !== false}
        onChange={option => this.handleChange(option)}
        onInputChange={inputValue => this.handleOnInputChange(inputValue)}
        options={data}
        placeholder={placeholder}
        value={selected}
        isDisabled={disabled}
      />
    );
  }
}

export default connect(null)(FilteredDropDown);
